import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * BP-11 R17's other half: the page behind `26ad.in/delete-account`.
 *
 * Google Play requires **two** routes to account deletion, not one — the
 * in-app path (`DeleteAccount`, on `/me/privacy`) *and* a web URL that works
 * for somebody who has uninstalled the app and cannot sign in. That URL is
 * submitted with the listing and has to answer without a session, which is
 * why this page asks for nothing and stores nothing: it says where the
 * in-app path is, and what to do when it is out of reach.
 *
 * It deliberately does **not** take a phone number. A form on an
 * unauthenticated page that accepted "delete the account on this number"
 * would be a way to have somebody else's record erased, and a number typed
 * into it is a disclosure DPDP §6 gives nobody the right to make.
 */
export function DeleteAccountHelp(): JSX.Element {
  const { t } = useTranslation('dpdp');

  return (
    <section className="space-y-3" data-testid="delete-account-help">
      <h1 className="text-lg font-semibold">{t('dpdp.erase.title')}</h1>
      <p className="text-sm text-foreground">{t('dpdp.erase.body')}</p>
      <p className="text-sm text-foreground" data-testid="delete-account-help-signed-out">
        {t('dpdp.erase.signedOut')}
      </p>
    </section>
  );
}
